import { Text } from '@bufferapp/ui'
import { AltTag, Canva, Pencil } from '@bufferapp/ui/Icon'
import PersonIcon from '@bufferapp/ui/Icon/Icons/Person'

import type { Draft } from '../../entities/Draft'
import type { UserTag } from '../../stores/types'
import { StyledIconWrapper, StyledTagWrapper } from './styles'
import { Tooltip } from '@buffer-mono/popcorn'

export const renderTagOption = (
  tagCount: number | null,
  onClick: () => void,
): JSX.Element => (
  <Tooltip content="Tag">
    <StyledTagWrapper aria-label="Tag" onClick={onClick}>
      <StyledIconWrapper>
        <PersonIcon size="medium" />
      </StyledIconWrapper>
      {/* @ts-expect-error TS(2741) FIXME: Property 'type' is missing in type '{ children: nu... Remove this comment to see the full error message */}
      <Text>{tagCount}</Text>
    </StyledTagWrapper>
  </Tooltip>
)

export const renderCanvaEditOption = (onClick: () => void): JSX.Element => (
  <Tooltip content="Edit Canva Design">
    <StyledTagWrapper aria-label="Edit Canva Design" onClick={onClick}>
      <StyledIconWrapper>
        <Canva size="medium" />
      </StyledIconWrapper>
    </StyledTagWrapper>
  </Tooltip>
)

export const renderEditOption = (
  onClick: () => void,
  isImageTooBig: boolean,
): JSX.Element => (
  <Tooltip
    content={
      isImageTooBig
        ? 'Images larger than 75MP are not supported by the editor'
        : 'Edit'
    }
  >
    <StyledTagWrapper
      aria-label="Edit"
      aria-disabled={isImageTooBig}
      onClick={isImageTooBig ? undefined : onClick}
      $disabled={isImageTooBig}
    >
      <StyledIconWrapper>
        <Pencil size="medium" />
      </StyledIconWrapper>
    </StyledTagWrapper>
  </Tooltip>
)

export const renderAltOption = (onClick: () => void): JSX.Element => (
  <Tooltip content="Edit description">
    <StyledTagWrapper aria-label="Alt" onClick={onClick}>
      <StyledIconWrapper>
        <AltTag size="medium" />
      </StyledIconWrapper>
    </StyledTagWrapper>
  </Tooltip>
)

export const getTags = (
  draft: Draft,
  imageUrl: string,
): UserTag[] | undefined => {
  const media = draft.getImageByUrl(imageUrl)

  return media ? media.userTags : undefined
}
